var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{ref:"competitionChartBar",staticClass:"comBarChart",attrs:{"height":_vm.barChartHeight,"options":_vm.chartOptionsBar,"series":_vm.series},on:{"update:heightSetting":_vm.setHeight}})}
var staticRenderFns = []

export { render, staticRenderFns }